import { defineNuxtPlugin, useRuntimeConfig } from '#app';
import posthog from 'posthog-js';

/**
 * Detects if user is likely located in the US based on timezone and language
 * @returns {boolean} True if likely US-based, false otherwise
 */
const detectIsLikelyUS = (): boolean => {
  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const language = navigator.language || navigator.languages?.[0];
    const isLikelyUS =
      timeZone?.startsWith('America/') && language?.includes('en-US');
    return isLikelyUS;
  } catch {
    // Safe fallback: if detection fails, assume non-US (cookieless)
    return false;
  }
};

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const posthogApiKey = config.public.posthogApiKey || '';
  const posthogHost = config.public.posthogHost || 'https://us.i.posthog.com';

  // Only initialize if API key is present
  if (posthogApiKey) {
    // Detect user region and set persistence accordingly
    const isLikelyUS = detectIsLikelyUS();
    const persistence = isLikelyUS ? 'localStorage' : 'memory';

    posthog.init(posthogApiKey, {
      api_host: posthogHost,
      capture_pageview: false, // We'll handle this manually for more control
      persistence: persistence as any,
      // No debug logging
    });
  }

  // Make PostHog available throughout the app
  nuxtApp.provide('posthog', posthog);

  // PostHog is now properly configured
});
